import { render, staticRenderFns } from "./CorePaginationInfo.vue?vue&type=template&id=6002dbb8"
import script from "./CorePaginationInfo.vue?vue&type=script&lang=js"
export * from "./CorePaginationInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports